
type Props = {
    componentId: string;
    tabItemId: string;
    activeTab: number;
    isrtl: boolean;
}

const useA11y = ({ componentId, tabItemId, activeTab, isrtl, }: Props) => {

    // getTabs

    const get_tabs = () => document.querySelectorAll(`.${tabItemId} .react-tabs__tab[aria-disabled="false"]`);

    const onKeydown_tab = (event) => { onKeydown(event, event.currentTarget); }

    const onKeydown = (event, currentTab) => {

        let tgt = currentTab;
        let flag = false;
        let tabs = get_tabs();

        switch (event.key) {
            case 'ArrowLeft':
                isrtl ? moveFocusToNextTab(tgt) : moveFocusToPreviousTab(tgt);
                flag = true;
                break;
            case 'ArrowRight':
                isrtl ? moveFocusToPreviousTab(tgt) : moveFocusToNextTab(tgt);
                flag = true;
                break;
            case 'Home':
                moveFocusToTab(tabs[0].id);
                flag = true;
                break;
            case 'End':
                moveFocusToTab(tabs[tabs.length - 1].id);
                flag = true;
                break;
            case 'Enter':
                onEnterTab(tgt);
                flag = true;
                break;
            case 'Tab':
                flag = !!onTabKeyKeydown(event);
                break;

            default:
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    const onTabKeyKeydown = (event): boolean => {
        // focus on next element and return a boolean for the keydown event's flag (preventDefault, stopPropagation)
        const tabs = get_tabs();
        const lastTab = (tabs[tabs.length - 1] as HTMLElement);

        if (event.shiftKey) return false;

        if (event.target === lastTab) return false;
        const focuseableElements = getFocusableElements();

        // check if selected tab has open tabpanel and focus on its 'close' button
        const openTabpanelCloseBtnEl = document.querySelector(`#${componentId} #Tabpanel-${componentId}-${tabItemId}-${activeTab} button.mst-tabItem-contentClose`);
        if (openTabpanelCloseBtnEl) {
            (openTabpanelCloseBtnEl as HTMLElement).focus();
            return true;
        }

        // if not, focus on next focusable element (skipping links of tabs)
        const currentElementIndex = focuseableElements.indexOf(event.target);
        // case next focusable element doesnt exist
        if (currentElementIndex === -1 || currentElementIndex === focuseableElements.length - 1) return;
        // focus next element
        (focuseableElements[currentElementIndex + 1] as HTMLElement).focus();
        return false;

    }

    const moveFocusToTab = (currentTabID) => {

        const tab = document.getElementById(currentTabID);

        if (tab) {
            (tab as HTMLElement).focus();
            // Case the Tab has only link:
            const isLinkTab = tab.className.includes('js-only-link');
            const linkEl = tab.querySelector('a.mst-overlay-link');

            if (isLinkTab && linkEl) return (linkEl as HTMLElement).focus();
        }
    }

    const moveFocusToPreviousTab = (currentTab) => {

        let index;
        const tabs = get_tabs();
        const tabs_arr = Array.from(tabs);

        if (currentTab === tabs[0]) {
            moveFocusToTab(tabs[tabs.length - 1].id);
        } else {
            index = tabs_arr.indexOf(currentTab);
            moveFocusToTab(tabs_arr[index - 1].id);
        }
    }

    const onEnterTab = (currentTab) => {

        const el = (currentTab as HTMLElement);
        const isLinkOnly = el.className.includes('js-only-link');
        const linkEl = el.querySelector('a.mst-overlay-link');

        if (isLinkOnly && linkEl) { (linkEl as HTMLLinkElement).click(); }
        else { el.click() }

    }

    const moveFocusToNextTab = (currentTab) => {

        let index;
        const tabs = get_tabs();
        const tabs_arr = Array.from(tabs);

        if (currentTab === tabs[tabs.length - 1]) {
            moveFocusToTab(tabs[0].id);
        } else {
            index = tabs_arr.indexOf(currentTab);
            moveFocusToTab(tabs_arr[index + 1].id);
        }
    }

    const getFocusableElements = (element?: Element) => {
        const query = 'button, [href], input, select, textarea, li.js-only-link[tabindex]:not([tabindex="-1"]) *';
        return Array.from((element || document).querySelectorAll(query));
    }

    const onBtnCloseKeyDown = (event) => { if (event.key === 'Enter') { (event.target as HTMLElement).click() } }


    return {
        onKeydown_tab,
        onBtnCloseKeyDown
    }
}

export default useA11y;